import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";

export const ProgressDialog = ({
  open,
  loadingMessage = "Operation in progress...",
  successMessage = "Successfully updated!",
  isSuccess = false,
  errorMessage,
  onClose,
  onRefresh,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isSuccess || errorMessage ? onClose : undefined}
      PaperProps={{
        sx: { borderRadius: 2, minWidth: 360, p: 2, textAlign: "center" },
      }}
    >
      <DialogTitle sx={{ fontWeight: "bold" }}>
        {errorMessage
          ? "⚠️ Operation Timeout"
          : isSuccess
          ? "✅ Operation Complete"
          : "⏳ Check Device Response"}
      </DialogTitle>

      <DialogContent>
        {errorMessage ? (
          <Typography variant="body1" sx={{ color: "white", mt: 1 }}>
            {errorMessage}
          </Typography>
        ) : isSuccess ? (
          <Typography variant="body1" sx={{ color: "white", mt: 1 }}>
            {successMessage}
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              mt: 1,
            }}
          >
            <CircularProgress color="#60a5fa" />
            <Typography variant="body1">{loadingMessage}</Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        {errorMessage ? (
          <Button variant="contained" color="error" onClick={onClose}>
            Close
          </Button>
        ) : isSuccess ? (
          <Button variant="contained" color="success" onClick={onRefresh}>
            OK
          </Button>
        ) :  null }
      </DialogActions>
    </Dialog>
  );
};
